$(document).ready(function () {
  
  $(window).scroll(function () {
    var scroll = $(window).scrollTop();
    var sticky = $(".header").offset().top;
    if (scroll >= 52) {
      $(".header").addClass("sticky");
      $(".header").closest(".section-header").addClass("sticky");
    } else {
      $(".header").removeClass("sticky");
      $(".header").closest(".section-header").removeClass("sticky");
    }
  });
});

$(".mobile-facets__open-label").click(function () {
  if ($(this).data("title") == "filter") {
    $(".mobile-facets__main details").show();
    $(".mobile-facets__main .mobile-facets__sort").hide();
    $(".sort-title").hide();
  } else if ($(this).data("title") == "sort") {
    $(".mobile-facets__main details").hide();
    $(".mobile-facets__main .mobile-facets__sort").show();
    $(".filter-title").hide();
    $(".sort-title").show();
  }
});

$(".size-chart").click(function () {
  $(".sizechart-popup").addClass("active");
});
$(".table_heading_show img").click(function () {
  setTimeout(function () {
    $(".sizechart-popup").removeClass("active");
  }, 100);
});

$(".dress_cat_filter li").click(function () {
  $(".dress_cat_filter li").removeClass("active");
  $(this).addClass("active");
  var get_active_second = $(".measure_cat_filter li.active")
    .text()
    .toLowerCase();
  var get_active_first = $(this).text().toLowerCase();
  $(".custom_innet_table_show .table_container").removeClass("active");
  $(
    ".custom_innet_table_show .table_container[data-show=" +
      get_active_first +
      "][data-measure=" +
      get_active_second +
      "]"
  ).addClass("active");
});

$(".measure_cat_filter li").click(function () {
  $(".measure_cat_filter li").removeClass("active");
  $(this).addClass("active");
  var get_active_second = $(".dress_cat_filter li.active").text().toLowerCase();
  var get_active_first = $(this).text().toLowerCase();
  $(".custom_innet_table_show .table_container").removeClass("active");
  $(
    ".custom_innet_table_show .table_container[data-show=" +
      get_active_second +
      "][data-measure=" +
      get_active_first +
      "]"
  ).addClass("active");
});

// Show the first tab and hide the rest
$("#tabs-nav li:first-child").addClass("active");
$(".tab-content").hide();
$(".tab-content:first").show();
// Click function
$(document).on("click", "#tabs-nav li", function () {
  $("#tabs-nav li").removeClass("active");
  $(this).addClass("active");
  $(".tab-content").hide();
  var activeTab = $(this).find("a").attr("href");
  $(activeTab).fadeIn();
  return false;
});

$(document).ready(function () {
  $(".first-variant").trigger("click");
  $(".first-variant").addClass("activee");
  $(
    ".var-cuslist.pro-variant label:first, .var-cuslist.pro-variant input:first"
  ).trigger("click");
});

$(document).on("click", ".card_swacthes-custom .size-btn", function () {
  // Remove 'activee' class from all buttons and add it to the clicked button
  $(this)
    .closest("variant-radios")  // Keeping variant-radios as it is
    .find(".card_swacthes-custom button")
    .removeClass("activee");
  $(this).addClass("activee");

  // Update product URL in the media and heading links
  let productUrl = $(this).attr("product-url");
  let productColName = $(this).attr("data-selected");
  let productTags = $(this).attr("tags");
  let cardParent = $(this).closest(".card-wrapper");
  let cardColNamePort = cardParent.find(".color-name .color_val");

  if(cardColNamePort.length > 0){
    cardColNamePort.text(productColName.replace(/-/g, " "));
  }

  let promoTags = cardParent.find(".promo-tags");
  if(promoTags.length > 0){
    let productTagList = productTags.split(" ,");
    let tags = "";
    productTagList.forEach(function(tag){
      if(tag){
         tags += "<span class='promo-tag'>"+tag.replace("PROMO_", "").replace(/-/g, " ")+"</span>"; 
      }
    })
    promoTags.html(tags);
    console.log({productTags})
  }else{
    promoTags.html("");
  }
  cardParent.find(".card__media a").attr("href", productUrl);
  cardParent.find(".card__heading a").attr("href", productUrl);

  // Handle image updates
  var getFirstImg = $(this).data("image1");
  var getSecondImg = $(this).data("image2");
  
  
  if (getFirstImg) {
    $(this)
      .closest(".grid__item")
      .find(".customgrid_parent")
      .html(
        '<img srcset="' + getFirstImg + '" src="' + getFirstImg + '" ' +
        'sizes="(min-width: 1200px) 267px, (min-width: 990px) calc((100vw - 130px) / 4), ' +
        '(min-width: 750px) calc((100vw - 120px) / 3), calc((100vw - 35px) / 2)" ' +
        'alt="" class="motion-reduce varstimg" loading="lazy" width="774" height="1024">' +
        
        '<img srcset="' + getSecondImg + '" src="' + getSecondImg + '" ' +
        'sizes="(min-width: 1200px) 267px, (min-width: 990px) calc((100vw - 130px) / 4), ' +
        '(min-width: 750px) calc((100vw - 120px) / 3), calc((100vw - 35px) / 2)" ' +
        'alt="" class="motion-reduce" loading="lazy" width="774" height="1024">'
      );
  }
});


  // $(this).parents('li.slider__slide').find('.var-size-wrap .size-var').each(function(){
  //   var vall = $(this).data('value').toLowerCase().replace(/[^A-Z0-9]/gi,'-');
  //   console.log(vall,'vall',val);
  //   if(val == vall){
  //      $(this).parents('li.slider__slide').find('.size-var[data-value="'+vall+'"]').show();
  //    }else{
  //     $(this).parents('li.slider__slide').find('.size-var[data-value="'+vall+'"]').hide();
  //    }
  // });

  // $(this).parents('li.slider__slide').find('.card__media span').each(function(){
  //   window.varoalt = ($(this).attr('alt').toLowerCase().replace(/[^A-Z0-9]/gi,'-'));
  //   var varoimage = ($(this).attr('data-image'));
  //   if(varoalt == val){
  //     $(this).parents('.slider__slide').find('.card__media img.varstimg').attr('srcset',varoimage);
  //     $(this).parents('.slider__slide').find('.card__media img.varstimg').attr('src',varoimage);
  //   }
  // });

$(".ad_to_cart_coll").on("click", function (e) {
  var product_id = $(this).find(".quickadd-variant").data("variantid");
  console.log(product_id, "Variant id");
});

$(".fit-varaint li").each(function () {
  var title = $(this).text();
  var tag = $(".pro-tags").text();
});

$(".product .card_swacthes-custom label").on("click", function () {
  window.val = $(this).data("selected");
  // console.log(val, 'value');
  $(".product__media-list li").each(function () {
    var color = $(this).data("color");
    // console.log(color, 'color');
    if (val == color) {
      $(this).show();
    } else {
      $(this).hide();
    }
  });
});

// lined/unlined text in product page to add to cart
$(".var-cuslist input").on("click", function () {
  var v = $(this).val();
  $(".lined-input").val(v);
});

// lined length popup
$(".find-your-length").click(function (e) {
  e.preventDefault();
  $("#find-length").addClass("active");
});
$("h1.find-length_heading img").click(function () {
  $("#find-length").removeClass("active");
});

$(".find-your-match").click(function (e) {
  e.preventDefault();
  $("#find-lined").addClass("active");
});
$("h1.find-lined_heading img").click(function () {
  $("#find-lined").removeClass("active");
});

// // mobile facets
// $(".mobile-prevent").on("click", function(e) {
//    e.preventDefault();
// });

$(".filter-btn").on("click", function (e) {
  $(".mobile-facets").addClass("show-filter");
  $(".mobile-facets").removeClass("show-sort");
});
$(".sort-btn").on("click", function (e) {
  $(".mobile-facets").addClass("show-sort");
  $(".mobile-facets").removeClass("show-filter");
});

if ($("body").hasClass("product")) {
  $(window).on("scroll", function () {
    if (
      $(window).scrollTop() >=
      $(".pro-top").offset().top +
        $(".pro-top").outerHeight() -
        window.innerHeight
    ) {
      $(".custom_scroll_section").css("display", "inline-block");
    } else {
      $(".custom_scroll_section").css("display", "none");
    }
  });
} 